AgeStore = require '../stores/age-store'

module.exports =
  statics:
    willTransitionTo: (transition) ->
      if AgeStore.ageVerification isnt 'true'
        transition.redirect '/age-gate'



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/mixins/age-protected-route.cjsx
 **/